<template>
    <div class="w-full hs-tabs">
        <div class="px-2 pt-2">
            <nav class="hs-tabs-nav" aria-label="Tabs">
                <button v-for="tab in tabs" :key="tab.id" @click="selectTab(tab.id)" :class="[
                    'hs-tab-btn focus:outline-none',
                    isActive(tab.id) ? 'hs-tab-btn--active' : 'hs-tab-btn--idle',
                ]">
                    {{ tab.label.toUpperCase() }}
                </button>
            </nav>
        </div>

        <div class="w-full px-6 sm:px-4 mt-4 pb-4 hs-tabs-content">
            <slot :name="'tab-' + activeTab"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "HSTabs",
    props: {
        tabs: {
            type: Array,
            required: true,
            validator: (tabs) => {
                return tabs.every(
                    (tab) => typeof tab.id === "string" && typeof tab.label === "string",
                );
            },
        },
        modelValue: {
            type: String,
            default: "",
        },
    },
    emits: ["update:modelValue"],
    data() {
        return {
            activeTab: this.modelValue || (this.tabs.length > 0 ? this.tabs[0].id : ""),
        };
    },
    methods: {
        selectTab(tabId) {
            this.activeTab = tabId;
            this.$emit("update:modelValue", tabId);
        },
        isActive(tabId) {
            return this.activeTab === tabId;
        },
    },
    watch: {
        modelValue(newValue) {
            if (newValue && this.tabs.some((tab) => tab.id === newValue)) {
                this.activeTab = newValue;
            }
        },
    },
};
</script>

<style scoped>
.hs-tabs {
    border: 1px solid var(--hs-border);
    border-radius: var(--hs-radius-xl);
    background: color-mix(in srgb, var(--hs-surface) 90%, transparent);
    box-shadow: var(--hs-shadow-soft);
}

.hs-tabs-nav {
    display: flex;
    gap: 0.5rem;
    overflow-x: auto;
    padding: 0.5rem;
    border-radius: 16px;
    background: color-mix(in srgb, var(--hs-bg-soft) 65%, transparent);
}

.hs-tab-btn {
    padding: 0.55rem 0.95rem;
    border-radius: 9999px;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    border: 1px solid transparent;
    white-space: nowrap;
    transition: all 0.22s ease;
}

.hs-tab-btn--active {
    color: #fff;
    border-color: transparent;
    background: linear-gradient(135deg, var(--hs-primary), var(--hs-primary-strong));
    box-shadow: var(--hs-shadow-soft);
}

.hs-tab-btn--idle {
    color: var(--hs-muted);
    background: color-mix(in srgb, var(--hs-surface) 85%, transparent);
    border-color: color-mix(in srgb, var(--hs-border) 72%, transparent);
}

.hs-tab-btn--idle:hover {
    color: var(--hs-primary-strong);
    border-color: color-mix(in srgb, var(--hs-primary) 26%, transparent);
}

.hs-tabs-content {
    animation: hs-float-in 0.35s ease;
}
</style>